import React, { useMemo } from 'react';
import { find, isArray, map } from 'lodash';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import uiStyles from './SortedSelect.module.scss';

const _collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export function _sortOptions(options) {
  // if options are grouped, only sort within groups
  if (find(options, ({ options }) => isArray(options))) {
    return map(options, (option) =>
      isArray(option.options) ? { ...option, options: _sortOptions(option.options) } : option,
    );
  }

  return options
    .concat()
    .sort((option1, option2) => _collator.compare(option1.label, option2.label));
}

function SortedSelect(props) {
  const {
    isCreatable,
    options,
    onRef,
    styles,
    menuPortalTarget,
    className,
    variant = undefined,
    ...componentProps
  } = props;

  const sortedOptions = useMemo(() => {
    return options ? _sortOptions(options) : [];
  }, [options]);

  const styleToApply = (() => {
    if (props.variant && uiStyles[props.variant]) {
      return uiStyles[props.variant];
    }
    return className;
  })();

  const selectProps = {
    options: sortedOptions,
    ref: onRef,
    menuPortalTarget: menuPortalTarget || undefined,
    styles: {
      ...styles,
      menuPortal: (base) => ({
        ...base,
        ...styles?.menuPortal?.(base),
        zIndex: 9999,
      }),
      menu: (base) => ({
        ...base,
        ...(styles?.menu ? styles.menu(base) : {}),
        zIndex: 9999,
      }),
    },
    className: styleToApply,
    ...componentProps,
  };

  if (isCreatable) {
    return (
      <CreatableSelect
        menuPlacement="auto"
        createOptionPosition="first"
        formatCreateLabel={(s) => `Use "${s}"`}
        {...selectProps}
        data-testid={props['data-testid']}
      />
    );
  }

  return <Select menuPlacement="auto" {...selectProps} data-testid={props['data-testid']} />;
}

export default SortedSelect;
